import { ReactElement } from 'react'

import { ALL_ROUTES } from '../constants/route-configs.constants'

export type Platform = 'default' | 'benestream'

export type RouteConfig = {
  key: string
  path: string
  requiresAuth: boolean
  label: string
  element: ReactElement
  policy?: string | null
  showInMenu: boolean
  menuConfig?: {
    icon?: string
    order?: number
    platforms?: Platform[]
  }
  parentKey?: string
}

export type MenuConfigBase = {
  id: string
  path: string
  title: string
  icon?: string
  policy?: string | null
}

export type DefaultMenuConfig = MenuConfigBase

export type BenestreamMenuConfig = MenuConfigBase & {
  route: {
    path: string
    policy: string | null
  }
}

export type NavigationOptions = {
  includeOrgPrefix?: boolean
  hardRedirect?: boolean
  skipValidation?: boolean
  replace?: boolean
}

export type BenestreamMenuOptions = {
  isSidebarCollapsed?: boolean
  borderBottom?: boolean
  showLogoutButton?: boolean
}

export type RouteKey = keyof typeof ALL_ROUTES

export type RouteParams = {
  [K in RouteKey]?: Record<string, string>
}

export type RoutesWithParams = {
  LEAD_DETAIL: { personId: string }
  ACCOUNT_DETAIL: { personId: string }
  SEARCH: { searchValue: string }
  CUSTOM_PATH: { path: string }
}

export enum DEFAULT_ROUTES {
  ACCOUNTS = 'ACCOUNTS',
  ACCOUNT_DETAIL = 'ACCOUNT_DETAIL',
  ACCOUNT_TICKET_DETAIL = 'ACCOUNT_TICKET_DETAIL',
  ADMINISTRATION = 'ADMINISTRATION',
  ADMINISTRATION_ABCS = 'ADMINISTRATION_ABCS',
  ADMINISTRATION_BENEFITS = 'ADMINISTRATION_BENEFITS',
  ADMINISTRATION_BENEFITS_CREATE = 'ADMINISTRATION_BENEFITS_CREATE',
  ADMINISTRATION_BENEFITS_DETAIL = 'ADMINISTRATION_BENEFITS_DETAIL',
  ADMINISTRATION_BENEFITS_PREVIEW = 'ADMINISTRATION_BENEFITS_PREVIEW',
  ADMINISTRATION_EMAIL_TEMPLATE = 'ADMINISTRATION_EMAIL_TEMPLATE',
  ADMINISTRATION_EMAIL_TEMPLATE_CREATE = 'ADMINISTRATION_EMAIL_TEMPLATE_CREATE',
  ADMINISTRATION_EMAIL_TEMPLATE_DETAIL = 'ADMINISTRATION_EMAIL_TEMPLATE_DETAIL',
  ADMINISTRATION_POLICIES = 'ADMINISTRATION_POLICIES',
  ADMINISTRATION_ROLES = 'ADMINISTRATION_ROLES',
  ADMINISTRATION_ROLES_DETAIL = 'ADMINISTRATION_ROLES_DETAIL',
  ADMINISTRATION_TAGS = 'ADMINISTRATION_TAGS',
  ADMINISTRATION_USERS = 'ADMINISTRATION_USERS',
  ADMINISTRATION_USERS_CREATE = 'ADMINISTRATION_USERS_CREATE',
  ADMINISTRATION_USERS_DETAILS = 'ADMINISTRATION_USERS_DETAILS',
  DASHBOARD = 'DASHBOARD',
  DATA_PROCESSING = 'DATA_PROCESSING',
  FORM_SUBMISSIONS = 'FORM_SUBMISSIONS',
  FORM_SUBMISSIONS_DETAIL = 'FORM_SUBMISSIONS_DETAIL',
  LEADS = 'LEADS',
  LEAD_CREATE = 'LEAD_CREATE',
  LEAD_DETAIL = 'LEAD_DETAIL',
  LEAD_TICKET_DETAIL = 'LEAD_TICKET_DETAIL',
  MERGING_TOOL = 'MERGING_TOOL',
  REPORTS = 'REPORTS',
  SEARCH = 'SEARCH',
  SMS_CAMPAIGNS = 'SMS_CAMPAIGNS',
  SMS_CAMPAIGNS_CREATE = 'SMS_CAMPAIGNS_CREATE',
  SMS_CAMPAIGNS_DETAIL = 'SMS_CAMPAIGNS_DETAIL',
  TASKS = 'TASKS',
  TICKETS = 'TICKETS',
  UPLOAD_FILE = 'UPLOAD_FILE',
  TEAM_LEAD_HUD = 'TEAM_LEAD_HUD',
  CLINICS = 'CLINICS',
  CLINIC_DETAIL = 'CLINIC_DETAIL',
  LOCATIONS = 'LOCATIONS',
}
